
export const STAGE =  {
    Local : 'local',
    Development : 'development',
    Staging : 'staging',
    Production : 'production',
  }
  
  export const stage = process.env.REACT_APP_LIMBER_STAGE || STAGE.Local;
  
  export const auth0Domain = process.env.REACT_APP_LIMBER_AUTH0_DOMAIN;
  
  export const auth0ClientId = process.env.REACT_APP_LIMBER_AUTH0_CLIENT_ID;
  
  export const auth0Audience = process.env.REACT_APP_LIMBER_AUTH0_AUDIENCE;
  
  
  
  
  // export const auth0ClientId = {
  //   [STAGE.Local]: '0OwaiTW7MVqU2JdTLNqa7zcNLITiyB8U',
  //   [STAGE.Development]: '0OwaiTW7MVqU2JdTLNqa7zcNLITiyB8U',
  //   [STAGE.Staging]: 'RtRuvt1jBxxy4bFD1KIQzHBL55JgZOds',
  //   [STAGE.Production]: 'nxE4s1ChyOfvxQ16HPvk3G95jIhqOaGj',
  // }[stage || STAGE.Local];
  // export const auth0Audience = {
  //   [STAGE.Local]: 'https://dev-admin-api.limberhealth.com/',
  //   [STAGE.Development]: 'https://dev-admin-api.limberhealth.com/',
  //   [STAGE.Staging]: 'https://stage-admin-api.limberhealth.com/',
  //   [STAGE.Production]: 'https://admin-api.limberhealth.com/',
  // }[stage || STAGE.Local];